import React from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import OfertasComponent from "../components/OfertasComponent";

const Ofertas = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-ofertas'>
                <OfertasComponent/>
            </div>
        </>
    );
};

export default Ofertas;